import React from 'react';
import { ModalBase } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

function SaveChangeForm({ onClose, openModal, handleRedirect, formRef, goBack }) {
  const { t } = useTranslation();

  const handleSaveAndRedirect = () => {
    if (formRef.current) {
      // eslint-disable-next-line
      formRef.current.dispatchEvent(new CustomEvent('submit', { detail: { submitter: 'saveAndRedirect', goBack } }));
    }
    onClose();
  };

  return (
    <ModalBase openModal={openModal} onClose={onClose} width='355px' height='190px'>
      <Container data-repa='stepper-saveChangeForm-container'>
        <Title>{t('publisher.navigation.modal.title')}</Title>
        <Description>{t('publisher.navigation.modal.text')}</Description>
        <ButtonsContainer data-repa='stepper-saveChangeForm-buttons'>
          <OnlyRedirect type='button' onClick={handleRedirect} data-repa='stepper-saveChangeForm-CTA1'>
            {t('publisher.navigation.modal.notSave')}
          </OnlyRedirect>
          <SaveAndRedirect
            type='button'
            id='saveAndRedirect'
            onClick={handleSaveAndRedirect}
            data-repa='stepper-saveChangeForm-CTA2'
          >
            {t('publisher.navigation.modal.save')}
          </SaveAndRedirect>
        </ButtonsContainer>
      </Container>
    </ModalBase>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.h4`
  height: 26px;
  margin: 22px 0px 4px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  color: ${select('black')};
`;

const Description = styled.p`
  height: 52px;
  padding: 0 1rem;
  margin-bottom: 20px;
  color: ${select('darkGray')};
  text-align: center;
  white-space: break-spaces;
`;

const buttonStyles = css`
  width: 48%;
  height: 40px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  cursor: pointer;
`;

const SaveAndRedirect = styled.button`
  color: ${select('white')};
  background-color: ${getColor('primary')};
  ${buttonStyles}
`;

const OnlyRedirect = styled.button`
  color: ${select('black')};
  background-color: ${select('white')};
  border: 1px solid ${getColor('primary')};
  ${buttonStyles}
`;

export { SaveChangeForm };
